<div class="sectionTop">
    <div class="header-content">
      <img src='../../../../../assets/images/portalHeaderIcon.svg' alt="My Raymond Icon" class="header-icon" tabindex="0">
    </div>
</div>
<div class="middle-sec">
    <p class="heading">{{contentPagelabels.heading}}</p>
    <p class="content" id='content' *ngFor="let content of contentData" tabindex="0" [innerHTML]="content| safeHtml" role="dialog"></p>
</div>
<kng-footer [state]="mainState.sectionBottom.footer"></kng-footer>
